import m from "../../node_modules/classnames/index.js";
import { jsx as l } from "../../_virtual/jsx-runtime.js";
function _({
  className: o,
  children: f,
  size: r = "full"
}) {
  return /* @__PURE__ */ l("div", {
    className: m("form-grid__row", {
      "form-grid__row--full": r === "full",
      "form-grid__row--two-third": r === "two-third",
      "form-grid__row--half": r === "half"
    }, o),
    children: f
  });
}
export {
  _ as FormRow
};
//# sourceMappingURL=FormRow.js.map
